import React from 'react';
import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';
import DTReplaceOrderWithCouponThenSendMacroNode from '../NodeGroups/DTCopyTextSendMacro/DTReplaceOrderWithCouponThenSendMacroNode/DTReplaceOrderWithCouponThenSendMacroNode';

const ReplaceOrderWithCouponThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTReplaceOrderWithCouponThenSendMacroNode
      showConfirmation={showConfirmationPage}
      message={'The items have been replaced.'}
    />
  );
};

export default ReplaceOrderWithCouponThenSendMacro;
